/*
* @Author: LiuMouLiang
* @Date:   2023-04-04 16:22:03
* @class:  业务单元处理
*/
import {
    _for,
    _toNumber,
    _isValue,
    _noValue,
    getObjVal,
    typeOf,
    findTarget,
    awaitTo,
    getOneObj,
} from 'tools';
import {
    toJson,
    trace,
} from './base';
import {
    getOssUpload,
} from '_libs/unit';

// 根据ProductMsg获取前端控制信息
export const getFrontControlInfoToProductMsg = function(productMsg){
    let frontControlInfo = {};
    if(typeOf(productMsg) !== 'object'){
        return frontControlInfo;
    };
    const _frontControlInfo = getObjVal(productMsg, 'front.frontControlInfo') ||
        getObjVal(productMsg, 'frontControlInfo');
    const tt = typeOf(_frontControlInfo);
    if(tt === 'string'){
        frontControlInfo = toJson(_frontControlInfo);
    }else if(tt === 'object'){
        frontControlInfo = _frontControlInfo;
    };
    return frontControlInfo;
};

// 查询页面配置数据
export const findTargetToPageSettings = function({
    prop, ID
}, pageSettings){
    let res = null;
    if(!pageSettings) {
        return res;
    };
    if(!(prop || ID)) return res;
    if(ID){
        res = findTarget(pageSettings, _ => _.id === ID);
    }else if(prop){
        res = findTarget(pageSettings, _ => _.prop === prop, 'children');
    };
    return res;
};

//获取发票配置数据
export const getInvoicePageSettings = function(frontControlInfo) {
    let pages = {};
    if(!frontControlInfo) return pages;
    const pageSettings = getObjVal(frontControlInfo,'pageSettings') || [];
    const invoicePageSettings = findTargetToPageSettings({
        ID: 'invoice'
    }, pageSettings);

    if(invoicePageSettings){
        const children = invoicePageSettings.children || [];
        pages = getOneObj(invoicePageSettings, 'children');

        const config = findTarget(children, _ => _.mode === 'formInvoiceRadio');
        if(config) {
            pages = Object.assign(pages, config);
            if(_noValue(pages.isShow)){
                pages.isShow = true;
            }
        }

    };
    return pages;
};

//获取页面配置数据中的独立模块
export const getPageSettingsSeparateToProductMsg = function(productMsg, frontControlInfo, forItemFn) {
    frontControlInfo = frontControlInfo || getFrontControlInfoToProductMsg(productMsg);
    const pageSettings = getObjVal(frontControlInfo,'pageSettings') || [];
    let res = [];
    let separate = {};

    _for(pageSettings, el => {
        if(el.type === 'separate') {
            separate[el.id] = el
        }else{
            res.push(el);
        };
        return forItemFn && forItemFn(el);
    });
    return [separate, res];
};

//设置发票信息
export const setBillInfoBean = function(billInfoBean, {
    groupCardId,
    groupName
}) {
    if(billInfoBean) {
        if(!billInfoBean['taxId'] && groupCardId) billInfoBean['taxId'] = groupCardId;
        if(groupName) {
            if(!billInfoBean['title']) billInfoBean['title'] = groupName;
            if(!billInfoBean['taxName']) billInfoBean['taxName'] = groupName;
        };
    }
    //特殊场景处理
    return billInfoBean;
};

export const getIsJumpWritePageToBaseInfo = function(baseInfo){
    const productType = _toNumber(getObjVal(baseInfo, 'productType'));
    const insureJumpPageType = getObjVal(baseInfo, 'insureJumpPageType'); // 1-使用产品详情页+报价页 2-使用中转页（H5嵌入、线下产品使用） 3-使用产品详情页
    let res = false;

    if(_isValue(productType)) {
        res = productType === 1 || productType === 3 && insureJumpPageType === 1;
    }else{
        res = true;
    };
    return res;
};

export const $getOssUpload = async function(file){
    if(typeOf(file) !== 'file') return '';
    const [ err, data ] = await awaitTo(getOssUpload(file));
    return data || '';
};



// WEBPACK FOOTER //
// ./src/libs/util/works.js